import TeamNotesMetadata from './TeamNotesMetadata'
import TeamNotesButtons from './TeamNotesButtons'
// eslint-disable-next-line import/no-internal-modules
import Panel from '@insided/deprecated-control/panel'
// eslint-disable-next-line import/no-internal-modules
import Textarea from '@insided/deprecated-control/ui-components/Textarea'
import classNames from 'classnames'

interface Props {
  contentInTextarea: string
  isLoading: boolean
  updatedBy?: string
  updatedAt?: string
  onContentChange: (value: string) => void
  onTextareaFocus: () => void
  onSaveChanges: () => void
  onCancel: () => void
  showButtons: boolean
}

const TeamNotesPanel = ({ contentInTextarea, isLoading, updatedBy, updatedAt, onContentChange, onTextareaFocus, onSaveChanges, onCancel, showButtons }: Props) => (
  <Panel collapsible title='Team notes'>
    <TeamNotesMetadata
      updatedBy={updatedBy}
      updatedAt={updatedAt}
      isLoading={isLoading}
    />
    <Textarea
      // eslint-disable-next-line @gorazdo/preact/prefer-classname
      class={classNames(
        'form-control',
        'team-notes__textarea',
        { 'is-loading': isLoading }
      )}
      placeholder='Leave a note to your moderation team'
      maxLength={50000}
      onContentChange={onContentChange}
      onTextareaFocus={onTextareaFocus}
      value={contentInTextarea}
    />
    {showButtons
      ? <TeamNotesButtons
          isLoading={isLoading}
          onSaveChanges={onSaveChanges}
          onCancel={onCancel}
        />
      : null}
  </Panel>
)

export default TeamNotesPanel
